import axios from '../api/index.js';

//查询综合服务列表
export let getIntegratedServicesQuery = (params) => {
    return axios.post(`/client/integrated/services/list`,params);
};

//查询综合服务介绍详情
export let getIntegratedServicesContent = (params) => {
    return axios.get(`/client/integrated/services/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/mixService.js